@use "../../styling/buttons.scss" as *;
@use '../../styling/colors.scss' as *;

.LinkButton {
  // This extend picks up the color and styling variants
  @extend %button;

  background: $color-white;
  height: 30px; // border top and bottom will add 2 px to the height = 32px in total
  padding: 0;

  a {
    display: inline-flex;
    text-decoration: none !important;
    padding: 7px 16px;
    align-items: center;
    width: 100%;
    justify-content: center;
    column-gap: 8px;
  }

  &.noMargin {
    margin-left: 0;
  }

  $button-types: 'primary'$color-white,
    'secondary'$theme-color-text;

  @each $name,
    $color in $button-types {
    &.#{$name} {
      a {
        color: $color !important;
      }
    }
  }

  &.disabled {
    opacity: 0.3;
    pointer-events: none;
  }

  &.text {
    border: 0 !important;
  }

  &.withBackground {
    background-color: $theme-color-secondary-button-background;
  }

  &.fullWidth {
    width: 100%;
  }
}
